import clsx from 'clsx';
import { ReactNode, useRef } from 'react';
import { type FC } from 'react';

import useSizeMe from '~hooks/useSizeMe';
import { getImageUrlForSize } from '~services/responsive-helpers';

export interface IResponsiveBackgroundProps {
  data: Entity;
  proportions: string;
  className?: {
    [x: string]: boolean;
  };
  placeholder?: boolean;
  children?: ReactNode;
}

const ResponsiveBackground: FC<IResponsiveBackgroundProps> = ({
  proportions,
  children,
  placeholder,
  data,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [size] = useSizeMe(ref);
  const backgroundStyle = data ? `url('${getImageUrlForSize(data, proportions, size.width)}')` : null;
  return (
    <div className="min-w-full h-full" ref={ref}>
      <div
        className={clsx({
          ...className,
        })}
        style={{ background: backgroundStyle }}
      >
        {placeholder && <div className="c-image-placeholder" />}
        {children}
      </div>
    </div>
  );
};

export default ResponsiveBackground;
